import { DataTable, Dialog, Loader } from "@/components";
import { InfoDialogProps } from "./types";
import useInfoDialog from "./useInfoDialog";

const InfoDialog = ({
  open,
  setOpen,
  glMasterId
}: InfoDialogProps) => {
  const { columns, isLoadingInfo, traceabilityInfoData,
    pageNumber, setPageNumber, pageSize, setPageSize, sorting, setSorting
  } = useInfoDialog({ glMasterId });

  return (
    <Dialog
      open={open} setOpen={setOpen}
      title={
        <div className="text-2xl font-bold text-primary">
          {"View Group Gl Information"}
          <div className="h-1 w-[30%] bg-primary rounded-full" />
        </div>
      }
      contentClassName="lg:!max-w-[700px] lg:!w-[700px]"
    >
      {isLoadingInfo ? <Loader /> : 
        <DataTable
          data={traceabilityInfoData?.data || []}
          columns={columns}
          pageNumber={pageNumber}
          pageSize={pageSize}
          setPageNumber={setPageNumber}
          setPageSize={setPageSize}
          totalPages={Math.ceil(traceabilityInfoData?.total / pageSize)}
          totalRecords={traceabilityInfoData?.total}
          serverSidePagination
          sorting={sorting}
          onSortingChange={setSorting}
        />
      }
    </Dialog>
  )
}

export default InfoDialog;